import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
import "firebase/analytics";

var firebaseConfig = {
    // ...your firebase credentials
    apiKey: "AIzaSyAq45TsYsNQvlYQucOu7v0rys6VTbjlTD8",
    authDomain: "originea-c05b6.firebaseapp.com",
    databaseURL: "https://originea-c05b6.firebaseio.com",
    projectId: "originea-c05b6",
    storageBucket: "originea-c05b6.appspot.com",
    messagingSenderId: "8700453911",
    appId: "1:8700453911:web:f46cb8aee53227df8ee852",
    measurementId: "G-VVS08112N9"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = firebase.auth();
// if (location.hostname === "localhost") {
//     auth.useEmulator("http://localhost:9099");
// }

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const twitterProvider = new firebase.auth.TwitterAuthProvider();

export const db = firebase.firestore();
// if (location.hostname === "localhost") {
//     db.useEmulator("localhost", 8080);
// }

export const timestamp = firebase.firestore.FieldValue.serverTimestamp();

export const storage = firebase.storage();
// if (location.hostname === "localhost") {
//     storage.useEmulator("localhost", 9919);
// }

export const functions = firebase.functions();
// if (location.hostname === "localhost") {
//     functions.useEmulator("localhost", 5001);
// }

export const analytics = firebase.analytics();